import { richTextResolver } from "@website-builder/utilities-index";

export default ({ header, programList }, { globalVariableWithURL = [] }) => {
	return {
		header,
		programList: getProgramList(programList, globalVariableWithURL),
	};
};

const getProgramList = (programList = [], globalVariableWithURL = []) => {
	return programList.map(({ gridClass = {}, ...program }) => {
		let bootStrapClass = "";
		const tags = gridClass.tags;
		if (tags && tags.length) {
			tags.forEach(({ text }) => {
				bootStrapClass = `${bootStrapClass} ${text}`;
			});
		}
		return {
			...program,
			details: richTextResolver(program.details, globalVariableWithURL),
			gridClass:
				bootStrapClass ||
				"col-xs-12, col-sm-12, col-md-4, col-lg-4, col-xl-4, col-xxl-4",
		};
	});
};
